const i18n = {
  'zh-CN': {
    selectAddress: '选择地址',
    shippingAddress: '收货地址',
    BilltoAddress: '收票地址',
    therequestfailed: '请求失败',
    backMall: '导入/导出',
    currentlist: '将为您导出当前列表的全部数据',
    currentFilter: '将为您导出当前筛选结果的全部数据',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteInformation: '确定删除信息吗?',
    successfullyDelete: '删除成功',
    selectedInformation: '确定删除所选信息吗?',
    loading: '加载中',
    operateSuccessfully: '操作成功',
    personCharge: '请选择负责人',
    confirmAddress: '请求地址错误,请确认地址!',
    operation: '操作',
    SelectLeastOnePieceOfData: '请选择数据',
    VerifyFailed: '校验未通过',
    auxiliary: '第',
    page: '页',
    ErrorCheckingBarData: '条数据校验错误.',
    FromRequired: '从对象必填',
    MaximumSupportForAddition: '最多支持添加',
    lineDetail: '行明细',
    silently: '您无【',
    pleaseContactAdministrator: '】对象的【查看列表】或【新建/编辑】权限，请联系管理员',
    search: '搜索',
    pleaseEnter: '请输入',
    PersonalAddress: '个人地址',
    administrative: '行政区域',
    newAddress: '新增地址',
    default: '默认',
    address: '地址',
    contacts: '联系人',
    contactWay: '联系方式',
    defaultSettings: '设置默认',
    delete: '删除',
    recompose: '修改',
    NoAddressavailableatTheMoment: '暂时没有可用地址',
    ThereOne: '暂时没有可用地址，去添加一个吧～',
    BusinessAddress: '企业地址',
    InventoryOrganization: '库存组织',
    supportuzzyearch: '请输入,支持模糊搜索',
    site: '地点',
    organizationName: '组织名称',
    AssociatedOrganizations: '关联组织列表',
    PleaseEnterContactPerson: '请输入联系人',
    yourContactInformation: '请输入联系方式',
    PleaseEnterContactPersons: '请输入联系人！',
    submit: '提交',
    nameShouldBeLessThan: '联系人姓名10个字符以内！',
    phoneNumberOrLandlineNumber: '请输入手机号或座机号！',
    landlineNumberFormatError: '手机号或座机号格式错误！',
    deleteAddress: '删除该地址后无法恢复，确认要删除吗？',
    addressSetSuccessfully: '设置默认地址成功',
    DeleteAddressSuccessfully: '删除地址成功',
    detailedAddress: '详细地址',
    enterTheEntireAddressNamePhoneNumber: '粘贴或者输入整段地址，姓名，电话，自动识别',
    PleaseFillInTheDetailedAddress: '请填写详细地址',
    postalCode: '邮政编码',
    consignee: '收货人',
    phone: '联系电话',
    SetToTheDefaultShippingAddress: '设置为默认收货地址',
    PleaseStreet: '请选择街道',
    PleaseSelectAddress: '请选择地址',
    PleaseEnterTheShippingAddress: '请输入收货地址',
    PleaseEnterTheCorrectZipCode: '请输入正确的邮政编码',
    PleaseFillInTheConsignee: '请填写收货人',
    PleaseEnterPhone: '请填写联系电话',
    PleaseenterTheCorrectMobilePhoneNumber: '请输入正确的手机号码！',
    EditTheShippingAddress: '编辑收货地址',
    cteatTheShippingAddress: '编辑收货地址',
    AddressModificationSuccessful: '地址修改成功',
    NewAddressSuccessfullyCreated: '地址新建成功',
    IncorrectParameters: '下载模板参数不正确',
    PleaseUploadFileFirst: '请先上传导入文件',
    ImportAgainLater: '导入失败，请稍后重试！',
    Stepone: '第1步：',
    ClickTheTemplateFile: '点击下方图标，下载模板文件。',
    StepTwo: '第2步：',
    AfterEditingAccordingTheTemplateFormatUload: '按模板格式编辑后，上传导入文件。',
    OnTheCross: '上传中',
    DownloadImportTemplateFile: '下载导入模板文件',
    UploadImportFile: '上传导入文件',
    support: '支持',
    PleaseSelectFileAndUploadIt: '请选择文件后上传',
    UploadfailedPleaseReUpload: '上传失败，请重新上传',
    TheUploadedFormatAnd: '上传文件为.xls/.xlsx格式，大小5M以内',
    andWithinMinsize: '.xls/.xlsx格式，大小在5M以内',
    UploadFailedPleaseTryAgain: '上传失败，请重试!',
    FileSelectionPleaseReselectMaximumSupportUploading: '文件选择错误，请重新选择，最大支持上传',
    FileSelectionPleaseReselectMinimumSupportUploading: '文件选择错误，不支持的文件大小0KB',
    heSizeOfTheFile: '大小文件',
    FileSelectionErrorPleaseReselectOnlySupport: '文件选择错误，请重新选择，仅支持',
    TypeOfFile: '类型文件',
    FileSelectionErrorPleaseReselect: '文件选择错误，请重新选择',
    UploadInitializationFailed: '上传初始化失败：',
    file: '文件',
    FileSelectionErrorAlreadyExists: '文件选择错误，已存在',
    MaximumAllowedUpload: '最多允许上传',
    mainFile: '个文件',
    uploadReady: '上传中...',
    awaiting: '等待中...'
  },
  'en': {
    selectAddress: 'Select address',
    shippingAddress: 'Receiving address',
    BilltoAddress: 'Mailing address of the invoice',
    therequestfailed: '请求失败',
    backMall: '导入/导出',
    currentlist: '将为您导出当前列表的全部数据',
    currentFilter: '将为您导出当前筛选结果的全部数据',
    tip: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteInformation: '确定删除信息吗?',
    successfullyDelete: 'Deleted successfully',
    selectedInformation: '确定删除所选信息吗?',
    loading: 'Loading',
    operateSuccessfully: 'Operation succeeded',
    personCharge: '请选择负责人',
    confirmAddress: '请求地址错误,请确认地址!',
    operation: 'Operation',
    SelectLeastOnePieceOfData: '请选择数据',
    VerifyFailed: '校验未通过',
    auxiliary: 'The ',
    page: '页',
    ErrorCheckingBarData: '条数据校验错误.',
    FromRequired: '从对象必填',
    MaximumSupportForAddition: '最多支持添加',
    lineDetail: '行明细',
    silently: '您无【',
    pleaseContactAdministrator: '】对象的【查看列表】或【新建/编辑】权限，请联系管理员',
    search: 'Search',
    pleaseEnter: 'Please enter',
    PersonalAddress: 'Personal address',
    administrative: 'Administrative Area',
    newAddress: 'New Address',
    default: 'Default',
    address: 'Address',
    contacts: 'Contact',
    contactWay: 'Contact information',
    defaultSettings: '设置默认',
    delete: 'Delete',
    recompose: 'Change',
    NoAddressavailableatTheMoment: 'There is no address available at the moment',
    ThereOne: 'There is no available address at the moment. Please add one first',
    BusinessAddress: 'Company Address ',
    InventoryOrganization: 'Storage organization',
    supportuzzyearch: 'Please enter. Fuzzy search supported',
    site: 'place',
    organizationName: 'Organization name',
    AssociatedOrganizations: '关联组织列表',
    PleaseEnterContactPerson: 'Please enter contact',
    yourContactInformation: 'Please enter contact information',
    PleaseEnterContactPersons: 'Please enter the contact!',
    submit: 'Submit',
    nameShouldBeLessThan: '联系人姓名10个字符以内！',
    phoneNumberOrLandlineNumber: '请输入手机号或座机号！',
    landlineNumberFormatError: '手机号或座机号格式错误！',
    deleteAddress: '删除该地址后无法恢复，确认要删除吗？',
    addressSetSuccessfully: '设置默认地址成功',
    DeleteAddressSuccessfully: '删除地址成功',
    detailedAddress: 'Detailed Address ',
    enterTheEntireAddressNamePhoneNumber: 'Paste or enter the entire address, name, phone number, automatic recognition.',
    PleaseFillInTheDetailedAddress: 'Please enter the detailed address',
    postalCode: 'Postcode',
    consignee: 'Receiver',
    phone: 'Contact number',
    SetToTheDefaultShippingAddress: 'Set as the default shipping address',
    PleaseStreet: 'Please select the street',
    PleaseSelectAddress: 'Please select the address',
    PleaseEnterTheShippingAddress: 'Please enter the shipping address',
    PleaseEnterTheCorrectZipCode: 'Please enter the correct postal code',
    PleaseFillInTheConsignee: '请填写收货人',
    PleaseEnterPhone: '请填写联系电话',
    PleaseenterTheCorrectMobilePhoneNumber: '请输入正确的手机号码！',
    EditTheShippingAddress: 'Edit the shipping address',
    cteatTheShippingAddress: 'Edit the shipping address',
    AddressModificationSuccessful: '地址修改成功',
    NewAddressSuccessfullyCreated: '地址新建成功',
    IncorrectParameters: '下载模板参数不正确',
    PleaseUploadFileFirst: '请先上传导入文件',
    ImportAgainLater: 'Import failed, please try again later!',
    Stepone: 'Step 1:',
    ClickTheTemplateFile: 'Click the icon below to download the template file.',
    StepTwo: 'Step 2:',
    AfterEditingAccordingTheTemplateFormatUload: 'After editing in the template format, upload the import file.',
    OnTheCross: 'Uploading',
    DownloadImportTemplateFile: 'Download the import template file',
    UploadImportFile: 'Uploading and Importing Files',
    support: 'support',
    PleaseSelectFileAndUploadIt: 'Please select the file and upload it',
    UploadfailedPleaseReUpload: 'Uploading failed, please try again.',
    TheUploadedFormatAnd: 'The uploaded file is in.xls/.xlsx format and within 5M in size',
    andWithinMinsize: '.xls/.xlsxformat，The size is within 5M',
    UploadFailedPleaseTryAgain: 'Upload failed, please try again!',
    FileSelectionPleaseReselectMaximumSupportUploading: 'The file selection is incorrect. Please select a new one. Upload is supported',
    FileSelectionPleaseReselectMinimumSupportUploading: 'The file selection is incorrect. The file size is not supported',
    heSizeOfTheFile: 'Size file',
    FileSelectionErrorPleaseReselectOnlySupport: 'The file selection is incorrect. Please select a new one. Only supported',
    TypeOfFile: 'Type file',
    FileSelectionErrorPleaseReselect: 'The selected files are incorrect, please select again',
    UploadInitializationFailed: 'Upload initialization failed',
    file: 'file',
    FileSelectionErrorAlreadyExists: 'The file selection is incorrect. Please select a new one. Only supported',
    MaximumAllowedUpload: 'Maximum upload allowed',
    mainFile: 'A file',
    uploadReady: 'Uploading…',
    awaiting: 'In waiting...'
  }
}
export default i18n
